import { connect } from "react-redux";
import * as fromActions from "../../actions";
import Form from "./form";

const mapStateToProps = ({ addSafetyPlanChecklistFormReducer }) => ({
	values: addSafetyPlanChecklistFormReducer,
	responseMessage: addSafetyPlanChecklistFormReducer.responseMessage,
});

const mapDispatchToProps = {
	onChange: fromActions.onAddSafetyPlanChecklistValueChange,
	onReset: fromActions.onAddSafetyPlanChecklistReset,
	onSave: fromActions.onAddSafetyPlanChecklistSave,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
